import StageDescription from './StageDescription'

class StageItemDescription {
  public id: number
  public type: 'chara' | 'acce'
  public acceName: string
  public x: number
  public y: number
  public angle: number
  public scale: number
  public order: number

  constructor (
    id: number,
    type: 'chara' | 'acce',
    acceName: string,
    x: number,
    y: number,
    angle: number,
    scale: number,
    order: number
  ) {
    if (id < 1 || !Number.isInteger(id)) { throw new Error('id must be positive int') }
    this.id = id
    this.type = type
    if ((type === 'acce' && acceName === 'CHARA') || (type === 'chara' && acceName !== 'CHARA')) { throw new Error('mismatch type and acceName') }
    this.acceName = acceName
    this.x = x
    this.y = y
    this.angle = angle
    this.scale = scale
    this.order = order
  }
}

export default StageItemDescription
